import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { AuthService } from './../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedientesService } from './../../services/expedientes.service';
import { MensajesService } from './../../services/mensajes.service';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-cliente-pyme',
  templateUrl: './cliente-pyme.component.html',
  styleUrls: ['./cliente-pyme.component.css']
})
export class ClientePymeComponent implements OnInit {

  @ViewChild("mensajeCliente") mensajeCliente: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;
  @ViewChild("mensajeLaboral") mensajeLaboral: ElementRef;
  @ViewChild("mensajeFiscal") mensajeFiscal: ElementRef;
  @ViewChild("mensajeContable") mensajeContable: ElementRef;
  @ViewChild("archivoSubir") archivoSubir:ElementRef;

  cliente={};
  direcciones=[];
  expedientes=[];
  ref;
  mensajesRecibidos;
  mensajesEnviados;
  activo:boolean=true;
  fiscal:boolean=false;
  laboral:boolean=false;
  contable:boolean=false;
  
  url:string;
  ordenacion={};

  aniosLaboral=[];
  aniosFiscal=[];
  aniosContable=[];
  nuevoLaboral=false;
  nuevoContable=false;
  nuevoFiscal=false;
  nuevosAnios={
    laboralyear:"",
    fiscalyear:"",
    contableyear:""
  }
  sectores=[
    "Administración",
    "Agricultura, ganadería y pesca",
    "Arquitectura",
    "Construcción",
    "Diseño Gráfico",
    "Educación",
    "Finanzas",
    "Industria",
    "Informática",
    "Ingeniería",
    "Ocio",
    "Organismos oficiales",
    "Telecomunicaciones",
    "Transporte",
    "Otros"
  ];

  currentPass:string;
  nextPass:string;
  nextPass2:string;

  paginaActualRecibidos:number=1;
  paginaSiguienteRecibidos:number;
  paginaAnteriorRecibidos:number;
  totalPaginasRecibidos:number;
  paginaActualEnviados:number=1;
  paginaSiguienteEnviados:number;
  paginaAnteriorEnviados:number;
  totalPaginasEnviados:number;

  constructor(public clientesPymesService:ClientesPymesService, public mensajesService:MensajesService,
    public expedientesService:ExpedientesService, public route:ActivatedRoute, public router:Router,
    private renderer:Renderer2, private location:Location, private auth:AuthService) {
      this.ref=this.route.snapshot.params["ref"];
      this.cliente={
        CLcif:""
      };
      this.mensajesEnviados=[];
      this.mensajesRecibidos=[];
      this.route.params.subscribe(params=>{
      
      this.ref=params.ref;
      if(this.ref!="nuevo"){
        this.cargarCliente();
      }
    });

    }

  ngOnInit() {
    this.ordenacion['campo']="MEfecha";
    this.ordenacion['orden']="DESC";
  }


  guardarCliente(myform:NgForm) {
    
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
      this.activo==true?this.cliente["CLactivo"]=1:this.cliente["CLactivo"]=0;
      this.laboral==true?this.cliente["CLservicio_laboral"]=1:this.cliente["CLservicio_laboral"]=0;
      this.fiscal==true?this.cliente["CLservicio_fiscal"]=1:this.cliente["CLservicio_fiscal"]=0;
      this.contable==true?this.cliente["CLservicio_contable"]=1:this.cliente["CLservicio_contable"]=0;
      if(this.ref=="nuevo"){
          this.clientesPymesService.insertCliente(this.cliente).subscribe(response=>{
            
            let texto=this.renderer.createText(response["mensaje"]);
            if(response["err"]==false){
              this.renderer.addClass(this.mensajeCliente.nativeElement, "text-success");
              setTimeout(() => {
                this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
                this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
                this.location.back();
              }, 2000);
            }else{
              this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
              this.renderer.addClass(this.mensajeCliente.nativeElement, "text-danger");
              setTimeout(() => {
                this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
              }, 2000);
            }
            
            
              
          }, err=>console.log(err));
        }else{
          this.clientesPymesService.updateCliente(this.cliente, this.archivoSubir.nativeElement.files[0]).subscribe(response=>{
            
            let texto=this.renderer.createText(response["msg"]);
            if(response["err"]==false){
              this.renderer.setStyle(this.mensajeCliente.nativeElement, "color", "green");
            }else{
              this.renderer.setStyle(this.mensajeCliente.nativeElement, "color", "red");
            }
            this.renderer.appendChild(this.mensajeCliente.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajeCliente.nativeElement,texto);
            }, 2000);
          
          });
        }
  }

  

  cargarCliente(){
    let id=Number(this.ref);
    this.clientesPymesService.getCliente(id).subscribe(resp=>{
      
      this.cliente=resp;
      
      this.cliente["CLactivo"]==1?this.activo=true:this.activo=false;
      this.cliente["CLservicio_laboral"]==1?this.laboral=true:this.laboral=false;
      this.cliente["CLservicio_fiscal"]==1?this.fiscal=true:this.fiscal=false;
      this.cliente["CLservicio_contable"]==1?this.contable=true:this.contable=false;
      if(this.cliente["CLlogo"]){
        this.url="https://app.solucionlegal.es/API/application/upload/pymes/"+this.cliente["CLcodigo"]+"/"+this.cliente["CLlogo"];
      }
      this.cargarMensajesRecibidos(this.paginaActualRecibidos);
      this.cargarMensajesEnviados(this.paginaActualEnviados);
    });
    this.clientesPymesService.AniosLaboral(this.ref)
    .subscribe(resp=>{
      this.aniosLaboral=resp;
      
    });
    this.clientesPymesService.AniosFiscal(this.ref)
    .subscribe(resp=>{
      this.aniosFiscal=resp;
      
    });
    this.clientesPymesService.AniosContable(this.ref)
    .subscribe(resp=>{
      this.aniosContable=resp;
      
    });
  }

  nuevoAnioLaboral(myform:NgForm){
    if(myform.valid){
      
      this.clientesPymesService.nuevoAnioLaboral(this.nuevosAnios.laboralyear)
      .subscribe(resp=>{
        if(resp["err"]==true){
          let texto=this.renderer.createText(resp["msg"]);
          this.renderer.appendChild(this.mensajeLaboral.nativeElement, texto);
          this.renderer.setStyle(this.mensajeLaboral.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeLaboral.nativeElement, texto);
          }, 1500);
        }else{
          this.nuevoLaboral=false;

          this.clientesPymesService.AniosLaboral(this.ref)
          .subscribe(resp=>{
            this.aniosLaboral=resp;
          });
        }
      });
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.appendChild(this.mensajeLaboral.nativeElement, texto);
      this.renderer.setStyle(this.mensajeLaboral.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeLaboral.nativeElement, texto);
      }, 1500);
    }
  }

  nuevoAnioFiscal(myform:NgForm){
    if(myform.valid){
      
      this.clientesPymesService.nuevoAnioFiscal(this.nuevosAnios.fiscalyear)
      .subscribe(resp=>{
        if(resp["err"]==true){
          let texto=this.renderer.createText(resp["msg"]);
          this.renderer.appendChild(this.mensajeFiscal.nativeElement, texto);
          this.renderer.setStyle(this.mensajeFiscal.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeFiscal.nativeElement, texto);
          }, 1500);
        }else{
          this.nuevoFiscal=false;

          this.clientesPymesService.AniosFiscal(this.ref)
          .subscribe(resp=>{
            this.aniosFiscal=resp;
          });
        }
      });
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.appendChild(this.mensajeFiscal.nativeElement, texto);
      this.renderer.setStyle(this.mensajeFiscal.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeFiscal.nativeElement, texto);
      }, 1500);
    }
  }

  nuevoAnioContable(myform:NgForm){
    if(myform.valid){
      
      this.clientesPymesService.nuevoAnioContable(this.nuevosAnios.contableyear)
      .subscribe(resp=>{
        if(resp["err"]==true){
          let texto=this.renderer.createText(resp["msg"]);
          this.renderer.appendChild(this.mensajeContable.nativeElement, texto);
          this.renderer.setStyle(this.mensajeContable.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeContable.nativeElement, texto);
          }, 1500);
        }else{
          this.nuevoContable=false;

          this.clientesPymesService.AniosContable(this.ref)
          .subscribe(resp=>{
            this.aniosContable=resp;
          });
        }
      });
    }else{
      let texto=this.renderer.createText("Hay errores en el formulario.");
      this.renderer.appendChild(this.mensajeContable.nativeElement, texto);
      this.renderer.setStyle(this.mensajeContable.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeContable.nativeElement, texto);
      }, 1500);
    }
  }

  

  cargarMensajesEnviados(pagina){
    this.mensajesService.getMensajesEnviados(this.cliente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesEnviados=resp["mensajes"];
      this.paginaActualEnviados=parseInt(resp["pagina"]);
      this.paginaAnteriorEnviados=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteEnviados=parseInt(resp["pag_siguiente"]);
      this.totalPaginasEnviados=parseInt(resp["total_paginas"]);
    });
  }
  
  cargarMensajesRecibidos(pagina){
    this.mensajesService.getMensajesRecibidos(this.cliente, pagina, this.ordenacion).subscribe(resp=>{
      this.mensajesRecibidos=resp["mensajes"];
      this.paginaActualRecibidos=parseInt(resp["pagina"]);
      this.paginaAnteriorRecibidos=parseInt(resp["pag_anterior"]);
      this.paginaSiguienteRecibidos=parseInt(resp["pag_siguiente"]);
      this.totalPaginasRecibidos=parseInt(resp["total_paginas"]);
    });
  }

  previousPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaAnteriorRecibidos);
  }

  previousPageEnviados(){
    this.cargarMensajesEnviados(this.paginaAnteriorEnviados);
  }

  nextPageRecibidos(){
    this.cargarMensajesRecibidos(this.paginaSiguienteRecibidos);
  }

  nextPageEnviados(){
    this.cargarMensajesEnviados(this.paginaSiguienteEnviados);
  }

  reiniciarCliente(){
    if(this.ref!='nuevo'){
      this.cargarCliente();
    }else{
      this.cliente={};
    }
    
  }

  volver(){
    this.location.back();
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    
    this.cargarMensajesEnviados(this.paginaActualEnviados);
    this.cargarMensajesRecibidos(this.paginaActualRecibidos);
    
  }



  onSelectFile(event) { // called each time file input changes
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.url = event.target['result'];
      }
    }
  }

  borrarAnio(tipo, anio){
    let respuesta=prompt('Si desea borrar este año, escriba "borrar" en el campo de texto.');
    if(respuesta==="borrar"){
      this.clientesPymesService.borrarAnio(this.cliente["CLcodigo"], tipo, anio)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.clientesPymesService.AniosLaboral(this.ref)
        .subscribe(resp=>{
          this.aniosLaboral=resp;
        });

        this.clientesPymesService.AniosFiscal(this.ref)
        .subscribe(resp=>{
          this.aniosFiscal=resp;
        });

        this.clientesPymesService.AniosContable(this.ref)
        .subscribe(resp=>{
          this.aniosContable=resp;
        });
        
      });
    }else{
      alert("Año no borrado.");
    }
    
  }

  eliminarMensajeRecibido(codigo){
    this.mensajesService.eliminarMensajeRecibidoClientePymes(codigo)
    .subscribe(resp=>{
      this.cargarMensajesRecibidos(this.paginaActualRecibidos);
    });
  }

  eliminarMensajeEnviado(codigo){
    this.mensajesService.eliminarMensajeEnviadoClientePymes(codigo)
    .subscribe(resp=>{
      this.cargarMensajesEnviados(this.paginaActualEnviados);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/cliente-pyme/cliente-pyme.component.ts